import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useContext,
} from "react";
import { type IHotelsFilters } from "../../types/interfaces";

export interface HotelFiltersContextValue {
  filters: IHotelsFilters | null;
  defaultFilters: IHotelsFilters | null;
  activeFilters: Partial<Record<keyof IHotelsFilters, boolean>> | null;
  updateFilters: Dispatch<SetStateAction<IHotelsFilters | null>>;
  resetFilters: () => void;
}

export const HotelFiltersContext =
  createContext<HotelFiltersContextValue | null>(null);

export const useHotelFiltersContext = () => {
  const context = useContext(HotelFiltersContext);
  if (!context) {
    throw new Error(
      "useHotelFiltersContext must be used within a HotelFiltersProvider",
    );
  }
  return context;
};
